export const ROLE_MAP = {
  ADMIN: 'admin',
  USER: 'user',
  MANAGER: 'manager',
  ADMIN_PARTNER: 'adminPartner'
}

export const ROLE = [
  ROLE_MAP.ADMIN,
  ROLE_MAP.USER,
  ROLE_MAP.MANAGER,
  ROLE_MAP.ADMIN_PARTNER
]

export const ROLE_RATIO = {
  [ROLE_MAP.USER]: 1,
  [ROLE_MAP.ADMIN_PARTNER]: 2,
  [ROLE_MAP.MANAGER]: 3,
  [ROLE_MAP.ADMIN]: 4
}
